(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sooqja-build-set"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(){document.querySelectorAll('[data-sq-set]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const cards=[...root.querySelectorAll('[data-set-item]')],button=root.querySelector('[data-set-add]'),status=root.querySelector('[data-set-status]'),label=button.textContent;root.querySelectorAll('[data-set-controls],[data-set-footer]').forEach(el=>el.hidden=false);const picked=()=>cards.filter(card=>card.querySelector('[data-set-check]').checked).map(card=>({id:card.querySelector('[data-set-variant]').value,quantity:1,price:Number(card.querySelector('[data-set-variant]').selectedOptions[0].dataset.price)}));function update(){const items=picked(),total=items.reduce((n,item)=>n+item.price,0);root.querySelector('[data-set-total]').textContent=new Intl.NumberFormat(document.documentElement.lang||'ar',{style:'currency',currency:root.dataset.currency}).format(total/100);button.disabled=!items.length||root.dataset.busy==='1';}root.addEventListener('change',update);update();button.addEventListener('click',async()=>{if(root.dataset.busy==='1')return;const items=picked();if(!items.length){status.textContent=root.dataset.empty;return;}root.dataset.busy='1';button.disabled=true;button.textContent=root.dataset.working;root.querySelectorAll('input,select').forEach(el=>el.disabled=true);status.textContent='';let added=false;try{const operation=async()=>{const response=await fetch(root.dataset.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items.map(({id,quantity})=>({id,quantity}))})});const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||root.dataset.error);return result;};window.sqCartWritesPending=(window.sqCartWritesPending||0)+1;const pending=(window.sqCartMutation||Promise.resolve()).catch(()=>{}).then(operation).finally(()=>window.sqCartWritesPending--);window.sqCartMutation=pending;const result=await pending;added=true;status.textContent=root.dataset.success;for(const item of result.items||[]){document.dispatchEvent(new CustomEvent('sooqja:cart:add-success',{detail:{placement:'build_set',currency:root.dataset.currency,item:{product_id:String(item.product_id),variant_id:String(item.variant_id||item.id),title:item.product_title||item.title,quantity:1,price:Number(item.final_price??item.price)/100}}}));}window.location.assign(root.dataset.cartUrl);}catch(error){status.textContent=added?root.dataset.success:root.dataset.error;}finally{delete root.dataset.busy;root.querySelectorAll('input,select').forEach(el=>el.disabled=false);button.textContent=label;update();}});});}init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sooqja-discovery-tabs"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;const tabs=Array.from(root.querySelectorAll('[data-discovery-tab]')),panel=root.querySelector('[data-discovery-panel]'),nav=root.querySelector('[data-discovery-tabs]'),all=root.querySelector('[data-discovery-all]');if(!tabs.length)return;root.dataset.ready='true';nav.setAttribute('role','tablist');panel.setAttribute('role','tabpanel');panel.tabIndex=0;function select(tab,replace){tabs.forEach(t=>{const active=t===tab;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});panel.setAttribute('aria-labelledby',tab.id);all.href=tab.href;if(replace){const source=root.querySelector('[data-discovery-content="'+tab.dataset.discoveryTab+'"]');if(source)panel.replaceChildren(source.content.cloneNode(true));}}tabs.forEach(tab=>{tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panel.id);tab.addEventListener('click',e=>{if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();select(tab,true)});tab.addEventListener('keydown',e=>{let index=tabs.indexOf(tab);const rtl=getComputedStyle(nav).direction==='rtl';if(e.key==='ArrowRight')index+=rtl?-1:1;else if(e.key==='ArrowLeft')index+=rtl?1:-1;else if(e.key==='Home')index=0;else if(e.key==='End')index=tabs.length-1;else if(e.key===' '){e.preventDefault();select(tab,true);return}else return;e.preventDefault();const next=tabs[(index+tabs.length)%tabs.length];next.focus();select(next,true)})});select(tabs[0],false)}document.querySelectorAll('[data-sq-discovery]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-sq-discovery]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sooqja-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    const choices = [...root.querySelectorAll('[data-hero-choice]')];
    const controls = root.querySelector('[data-hero-controls]');
    if (slides.length < 2 || !controls) return;
    const stage = root.querySelector('[data-hero-stage]');
    const play = root.querySelector('[data-hero-play]');
    const icon = root.querySelector('[data-hero-play-icon]');
    const status = root.querySelector('[data-hero-status]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let current = 0, timer, request = 0, start = null, hovering = false, visible = true;
    let paused = root.dataset.auto !== 'true' || motion.matches;
    const stop = () => clearTimeout(timer);
    const playState = () => {
      play.setAttribute('aria-label', paused ? root.dataset.play : root.dataset.pause);
      icon.textContent = paused ? '▷' : 'Ⅱ';
      root.dataset.autoplayState = paused ? 'paused' : 'running';
    };
    const canRotate = () => !paused && !hovering && visible && !document.hidden && root.isConnected;
    const schedule = () => {
      stop();
      if (canRotate()) timer = setTimeout(() => show(current + 1, false), Number(root.dataset.interval) || 5000);
    };
    const pause = () => { paused = true; request++; stop(); playState(); };
    const prepare = async slide => {
      const template = slide.querySelector('[data-hero-image]');
      if (template) {
        const copy = template.content.cloneNode(true);
        const image = copy.querySelector('img');
        if (image) image.loading = 'eager';
        template.replaceWith(copy);
      }
      const image = slide.querySelector('img');
      if (image && !image.complete && image.decode) { try { await image.decode(); } catch {} }
    };
    async function show(index, manual, restoreSlideFocus = false) {
      if (manual) pause();
      index = (index + slides.length) % slides.length;
      stop();
      const token = ++request;
      await prepare(slides[index]);
      if (token !== request || !root.isConnected || controller.signal.aborted) return;
      if (!manual && !canRotate()) { schedule(); return; }
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === index)));
      current = index;
      if (manual) status.textContent = slides[index].dataset.heroTitle;
      if (restoreSlideFocus) slides[index].querySelector('a')?.focus({ preventScroll: true });
      schedule();
    }
    choices.forEach((choice, i) => choice.addEventListener('click', () => show(i, true), options));
    root.querySelector('[data-hero-prev]').addEventListener('click', () => show(current - 1, true), options);
    root.querySelector('[data-hero-next]').addEventListener('click', () => show(current + 1, true), options);
    play.addEventListener('click', () => { paused = !paused; request++; playState(); schedule(); }, options);
    root.addEventListener('focusin', event => { if (event.target.matches(':focus-visible')) pause(); }, options);
    root.addEventListener('mouseenter', () => { hovering = true; request++; stop(); }, options);
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); }, options);
    root.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(current + (event.key === 'ArrowLeft' ? 1 : -1), true, !!event.target.closest('[data-hero-slide]'));
    }, options);
    stage.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch' && !event.target.closest('a,button')) start = { x: event.clientX, y: event.clientY };
    }, options);
    stage.addEventListener('pointerup', event => {
      if (!start) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx > 0 ? 1 : -1), true);
    }, options);
    stage.addEventListener('pointercancel', () => { start = null; }, options);
    document.addEventListener('visibilitychange', () => { request++; schedule(); }, options);
    motion.addEventListener('change', () => { if (motion.matches) pause(); }, options);
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (!visible) request++;
      schedule();
    }, { threshold: .15 }) : null;
    observer?.observe(root);
    document.addEventListener('shopify:block:select', event => {
      const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
      if (index >= 0) show(index, true);
    }, options);
    instances.set(root, () => { request++; stop(); observer?.disconnect(); controller.abort(); instances.delete(root); });
    controls.hidden = false;
    root.classList.add('is-ready');
    playState();
    schedule();
  }
  const roots = node => [...node.matches?.('[data-sq-hero]') ? [node] : [], ...node.querySelectorAll('[data-sq-hero]')];
  roots(document).forEach(init);
  document.addEventListener('shopify:section:load', event => roots(event.target).forEach(init));
  document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => instances.get(root)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sooqja-magic-books-order"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-magic-books-order]').forEach((section) => {
    const form = section.querySelector('[data-order-form]');
    const arabicInput = section.querySelector('[data-arabic-quantity]');
    const englishInput = section.querySelector('[data-english-quantity]');
    const totalOutput = section.querySelector('[data-order-total]');
    const errorOutput = section.querySelector('[data-order-error]');
    const unitPrice = Number(section.dataset.unitPrice);
    const shippingPrice = Number(section.dataset.shippingPrice);

    const cleanQuantity = (input) => {
      const maximum = Number(input.max) || 20;
      const value = Math.max(0, Math.min(maximum, Number.parseInt(input.value, 10) || 0));
      input.value = value;
      return value;
    };

    const updateTotal = () => {
      const quantity = cleanQuantity(arabicInput) + cleanQuantity(englishInput);
      totalOutput.textContent = quantity > 0 ? (quantity * unitPrice) + shippingPrice : 0;
    };

    section.querySelectorAll('[data-quantity-control]').forEach((control) => {
      const input = control.querySelector('input');
      control.querySelector('[data-quantity-minus]').addEventListener('click', () => {
        input.value = Math.max(0, cleanQuantity(input) - 1);
        updateTotal();
      });
      control.querySelector('[data-quantity-plus]').addEventListener('click', () => {
        input.value = Math.min(Number(input.max) || 20, cleanQuantity(input) + 1);
        updateTotal();
      });
      input.addEventListener('input', updateTotal);
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      errorOutput.hidden = true;
      const arabicQuantity = cleanQuantity(arabicInput);
      const englishQuantity = cleanQuantity(englishInput);
      if ((arabicQuantity + englishQuantity) === 0) {
        errorOutput.textContent = section.dataset.emptyMessage;
        errorOutput.hidden = false;
        return;
      }
      if (!form.reportValidity()) return;

      const data = new FormData(form);
      const total = ((arabicQuantity + englishQuantity) * unitPrice) + shippingPrice;
      const lines = [section.dataset.messageTitle];
      if (arabicQuantity > 0) lines.push(`${section.dataset.arabicLabel}: ${arabicQuantity} × ${unitPrice}`);
      if (englishQuantity > 0) lines.push(`${section.dataset.englishLabel}: ${englishQuantity} × ${unitPrice}`);
      lines.push(`${section.dataset.shippingLabel}: ${shippingPrice}`);
      lines.push(`${section.dataset.totalLabel}: ${total}`);
      lines.push('');
      lines.push(`${section.dataset.nameLabel}: ${data.get('name')}`);
      lines.push(`${section.dataset.phoneLabel}: ${data.get('phone')}`);
      lines.push(`${section.dataset.addressLabel}: ${data.get('address')}`);

      const destination = `https://wa.me/${section.dataset.whatsappNumber}?text=${encodeURIComponent(lines.join('\n'))}`;
      window.location.href = destination;
    });

    updateTotal();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sooqja-main-collection"] && !Shopify.designMode) return;
  try {
    
(()=>{
  function init(root){
    if(root.dataset.scrollReady)return;
    const grid=root.querySelector('[data-sq-product-grid]'),more=root.querySelector('[data-sq-more]');
    if(!grid||!more||!window.fetch||!window.DOMParser)return;
    root.dataset.scrollReady='1';root.classList.add('is-auto-loading');more.hidden=false;
    const status=more.querySelector('[data-sq-load-status]'),link=more.querySelector('[data-sq-load-next]'),fallback=more.querySelector('[data-sq-load-fallback]');
    if(!link){status.textContent=more.dataset.end;return}
    const cacheKey='sq-collection-v3:'+String(window.Shopify?.theme?.id||'')+':'+location.pathname+'?'+new URLSearchParams(location.search).toString();
    let restored=false;
    try{
      const navigation=performance.getEntriesByType('navigation')[0];
      const cached=JSON.parse(sessionStorage.getItem(cacheKey)||'null');
      if(navigation?.type==='back_forward'&&cached&&Date.now()-cached.time<300000&&cached.section===root.dataset.sqCollection&&cached.html.length<1600000){
        const doc=new DOMParser().parseFromString(cached.html,'text/html');doc.querySelectorAll('script').forEach(el=>el.remove());
        grid.replaceChildren(...doc.body.childNodes);more.dataset.page=String(cached.page);
        if(cached.next){link.href=cached.next;fallback.href=cached.next}else{link.hidden=true;status.textContent=more.dataset.end;}
        requestAnimationFrame(()=>requestAnimationFrame(()=>window.scrollTo({top:cached.scroll,behavior:'instant'})));restored=true;
      }
    }catch(error){}
    let loading=false,failed=false,finished=restored&&link.hidden,page=Number(more.dataset.page),observer,controller;
    const lifecycle=new AbortController();
    function remember(){
      if(loading||grid.querySelector('[aria-busy=true]'))return;
      try{const html=grid.innerHTML;if(html.length<1600000)sessionStorage.setItem(cacheKey,JSON.stringify({time:Date.now(),section:root.dataset.sqCollection,html,page,next:finished?null:link.href,scroll:window.scrollY}));}catch(error){}
    }
    root.addEventListener('click',event=>{if(event.target.closest('.sq-card a[href]'))remember();},{signal:lifecycle.signal});
    window.addEventListener('pagehide',remember,{signal:lifecycle.signal});
    const seen=new Set([...grid.querySelectorAll('.sq-card__media')].map(a=>a.getAttribute('href')));
    const cleanUrl=value=>{const url=new URL(value,location.href);if(url.origin!==location.origin||url.pathname!==location.pathname)throw new Error('origin or path');url.searchParams.delete('section_id');url.searchParams.delete('sections');return url};
    async function loadNext(manual=false){
      if(loading||finished||!root.isConnected)return;
      loading=true;failed=false;observer?.unobserve(more);link.setAttribute('aria-disabled','true');grid.setAttribute('aria-busy','true');fallback.hidden=true;status.textContent=more.dataset.loading;
      const pending=new AbortController();controller=pending;const timeout=setTimeout(()=>pending.abort(),15000);
      try{
        const url=cleanUrl(link.href);url.searchParams.set('section_id',root.dataset.sqCollection);
        const response=await fetch(url,{signal:pending.signal,credentials:'same-origin',headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error('response');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const nextRoot=[...doc.querySelectorAll('[data-sq-collection]')].find(el=>el.dataset.sqCollection===root.dataset.sqCollection);
        const nextGrid=nextRoot?.querySelector('[data-sq-product-grid]'),nextMore=nextRoot?.querySelector('[data-sq-more]');
        const nextPage=Number(nextMore?.dataset.page);
        if(!nextGrid||!nextMore||nextPage!==page+1)throw new Error('page');
        const cards=[...nextGrid.children].filter(card=>{const href=card.querySelector('.sq-card__media')?.getAttribute('href');return href&&!seen.has(href)});
        if(!cards.length)throw new Error('empty');
        if(!root.isConnected||pending.signal.aborted)return;
        const next=nextMore.querySelector('[data-sq-load-next]');
        const nextUrl=next?cleanUrl(next.getAttribute('href')).href:null;
        const fragment=document.createDocumentFragment();cards.forEach(card=>{seen.add(card.querySelector('.sq-card__media').getAttribute('href'));card.querySelectorAll('script').forEach(script=>script.remove());card.querySelectorAll('img').forEach(img=>img.loading='lazy');fragment.append(card)});grid.append(fragment);
        page=nextPage;more.dataset.page=String(page);
        const moveFocus=manual||(!nextUrl&&document.activeElement===link);
        if(nextUrl){link.href=nextUrl;fallback.href=nextUrl}else{finished=true;link.hidden=true}
        status.textContent=more.dataset.addedLabel.replace('__COUNT__',String(cards.length)).replace('__TOTAL__',String(grid.children.length))+(finished?' '+more.dataset.end:'');
        if(moveFocus)cards[0].querySelector('a[href], button')?.focus({preventScroll:true});
        root.dispatchEvent(new CustomEvent('sooqja:collection:loaded',{bubbles:true,detail:{count:cards.length,page}}));
      }catch(error){failed=true;if(root.isConnected&&!lifecycle.signal.aborted){status.textContent=more.dataset.error;fallback.hidden=false}}
      finally{clearTimeout(timeout);loading=false;link.removeAttribute('aria-disabled');grid.removeAttribute('aria-busy');if(!failed&&!finished&&root.isConnected)observer?.observe(more)}
    }
    link.addEventListener('click',event=>{if(event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();loadNext(true)},{signal:lifecycle.signal});
    if('IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&!failed)loadNext()},{rootMargin:'0px 0px 600px 0px'});if(!finished)observer.observe(more)}
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){observer?.disconnect();controller?.abort();lifecycle.abort();delete root.dataset.scrollReady;}},{signal:lifecycle.signal});
  }
  document.querySelectorAll('[data-sq-collection]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sq-collection]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sooqja-main-search"]) return;
  try {
    
  if (!customElements.get('sooqja-search-results')) {
    customElements.define('sooqja-search-results', class extends HTMLElement {
      connectedCallback() {
        if (this.ready || this.dataset.mode !== 'infinite') return;
        this.grid = this.querySelector('[data-sq-search-grid]');
        this.nextLink = this.querySelector('[data-sq-search-next]');
        this.status = this.querySelector('[data-sq-search-status]');
        this.fallbackLink = this.querySelector('[data-sq-search-fallback]');
        this.sentinel = this.querySelector('[data-sq-search-pagination]');
        if (!this.grid || !this.nextLink || !this.status || !this.sentinel) return;
        this.ready = true;
        this.seen = new Set([...this.grid.querySelectorAll('[data-sq-search-item]')].map(item => item.dataset.productId));
        this.onClick = event => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.paused = false;
          this.loadNext(true);
        };
        this.nextLink.addEventListener('click', this.onClick);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.nearEnd = entries.some(entry => entry.isIntersecting);
            if (this.nearEnd && !this.paused) this.loadNext();
          }, { rootMargin: '400px 0px', threshold: 0 });
          if (this.dataset.nextUrl) this.observer.observe(this.sentinel);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.nextLink?.removeEventListener('click', this.onClick);
        this.ready = false;
      }

      fullPageURL(href) {
        const url = new URL(href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Invalid search response');
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        return url;
      }

      async loadNext(manual = false) {
        if (this.loading || this.paused || !this.dataset.nextUrl || !this.isConnected) return;
        this.loading = true;
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 15000);
        this.grid.setAttribute('aria-busy', 'true');
        this.nextLink.setAttribute('aria-disabled', 'true');
        this.status.textContent = this.dataset.loadingLabel;
        if (this.fallbackLink) this.fallbackLink.hidden = true;
        try {
          const url = this.fullPageURL(this.dataset.nextUrl);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Search request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = doc.querySelector('sooqja-search-results');
          const incomingGrid = incoming?.querySelector('[data-sq-search-grid]');
          const page = Number(incoming?.dataset.currentPage);
          if (!incomingGrid || incoming.dataset.sectionId !== this.dataset.sectionId || page !== Number(this.dataset.currentPage) + 1) throw new Error('Invalid search page');
          const nextURL = incoming.dataset.nextUrl ? this.fullPageURL(incoming.dataset.nextUrl) : null;
          if (!this.isConnected || controller.signal.aborted) return;
          const fragment = document.createDocumentFragment();
          const added = [];
          incomingGrid.querySelectorAll('[data-sq-search-item]').forEach(item => {
            const id = item.dataset.productId;
            if (!id || this.seen.has(id)) return;
            this.seen.add(id);
            item.querySelectorAll('script').forEach(script => script.remove());
            item.querySelectorAll('img').forEach(img => img.loading = 'lazy');
            added.push(item);
            fragment.append(item);
          });
          if (!added.length) throw new Error('Empty search page');
          this.grid.append(fragment);
          this.dataset.currentPage = String(page);
          this.grid.dataset.currentPage = String(page);
          this.dataset.nextUrl = nextURL ? nextURL.pathname + nextURL.search : '';
          if (nextURL) {
            this.nextLink.href = this.dataset.nextUrl;
            if (this.fallbackLink) this.fallbackLink.href = this.dataset.nextUrl;
          }
          const moveFocus = manual || (!nextURL && document.activeElement === this.nextLink);
          this.nextLink.hidden = !nextURL;
          const announcement = this.dataset.addedLabel.replace('__COUNT__', String(added.length)).replace('__TOTAL__', String(this.grid.querySelectorAll('[data-sq-search-item]').length));
          this.status.textContent = announcement + (nextURL ? '' : ' ' + this.dataset.endLabel);
          if (moveFocus) added[0].querySelector('a[href], button')?.focus({ preventScroll: true });
          document.dispatchEvent(new CustomEvent('productsLoaded', { detail: { page, totalPages: Number(incomingGrid.dataset.totalPages), hasNextPage: !!nextURL, source: 'sooqja-search' } }));
          if (!nextURL) this.observer?.disconnect();
        } catch (error) {
          if (this.isConnected) {
            this.paused = true;
            this.status.textContent = this.dataset.errorLabel;
            if (this.fallbackLink) this.fallbackLink.hidden = false;
          }
        } finally {
          clearTimeout(timeout);
          this.loading = false;
          this.grid.removeAttribute('aria-busy');
          this.nextLink.removeAttribute('aria-disabled');
          if (this.observer && !this.paused && this.dataset.nextUrl && this.isConnected) {
            this.observer.unobserve(this.sentinel);
            this.observer.observe(this.sentinel);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sooqja-sand-picker"] && !Shopify.designMode) return;
  try {
    
(()=>{
function normalize(value){return String(value||'').toLowerCase().replace(/[٠-٩]/g,c=>'٠١٢٣٤٥٦٧٨٩'.indexOf(c)).replace(/[۰-۹]/g,c=>'۰۱۲۳۴۵۶۷۸۹'.indexOf(c)).replace(/٫/g,'.');}
function facts(record){
  const text=normalize(record.source),kind=normalize(record.kind),title=normalize(record.title),uses=[];
  if(/ظهر|لابتوب|لاب توب|كمبيوتر|backpack|laptop/.test(kind+' '+title)||/عمل|جامعة|دراس|office|college|school|business/.test(text))uses.push('daily');
  if(/سفر|رحلات|travel|luggage/.test(kind+' '+title+' '+text))uses.push('travel');
  if(/رياض|جيم|gym|duffel|sports/.test(kind+' '+title+' '+text))uses.push('gym');
  if(/كتف|كروس|صدر|محافظ|حقائب يد|حقائب نسائية|crossbody|sling|wallet/.test(kind)&&!/لابتوب|laptop/.test(title))uses.push('small');
  const patterns=[/(?:لابتوب|لاب توب|الكمبيوتر المحمول(?:ة)?|كمبيوتر محمول)[^0-9.,،;]{0,65}(\d{2}(?:\.\d)?)[ -]*(?:بوصة|إنش|انش|″|")/g,/laptops?[^0-9.,،;]{0,65}(\d{2}(?:\.\d)?)[ -]*(?:inch(?:es)?|″|")/g,/(\d{2}(?:\.\d)?)[ -]*(?:inch(?:es)?|″|")[ -]*laptops?/g];
  const values=[];
  for(const pattern of patterns){for(const match of text.matchAll(pattern)){
    const n=Number(match[1]),before=text.slice(Math.max(0,match.index-25),match.index);
    if(n>=10&&n<=20&&!/تابلت|آيباد|آي باد|ايباد|آي‌باد|ipad|tablet/.test(match[0])&&!/لا يتسع|غير مناسب|not fit|not suitable|without/.test(before))values.push(n);
  }}
  const unique=[...new Set(values)];
  return {...record,uses,laptop:unique.length===1?unique[0]:null,laptopCandidate:/لابتوب|لاب توب|كمبيوتر|laptop/.test(text+' '+title+' '+kind)};
}
function select(records,filters){
  const eligible=records.filter(r=>(filters.use==='any'||r.uses.includes(filters.use))&&(!filters.budget||r.price<=filters.budget));
  const matches=eligible.filter(r=>!filters.laptop||(r.laptop!==null&&r.laptop>=filters.laptop));
  const unknown=filters.laptop?eligible.filter(r=>r.laptop===null&&r.laptopCandidate):[];
  const byPrice=(a,b)=>a.price-b.price||a.id.localeCompare(b.id);
  return {matches:matches.sort(byPrice),unknown:unknown.sort(byPrice)};
}
function init(){document.querySelectorAll('[data-sq-picker]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='1';
  const form=root.querySelector('[data-picker-form]'),details=root.querySelector('details'),status=root.querySelector('[data-picker-status]'),result=root.querySelector('[data-picker-results]'),grid=root.querySelector('[data-picker-grid]'),more=root.querySelector('[data-picker-more]'),unknown=root.querySelector('[data-picker-unknown]'),submit=form.querySelector('[type=submit]');
  let records=null,pending=null,visible=[],shown=0,request=0;
  form.hidden=false;result.hidden=true;
  async function load(){
    if(records)return records;if(pending)return pending;
    status.textContent=root.dataset.loading;submit.disabled=true;
    pending=(async()=>{
      const overrides=new Map([...root.querySelectorAll('[data-picker-override]')].map(t=>[t.dataset.id,t.dataset]));
      const first=new URL(root.dataset.catalog,location.origin);first.searchParams.set('section_id','sooqja-picker-catalog');
      const visited=new Set(),items=new Map();let next=first.href;
      while(next){
        if(visited.has(next))throw Error('pagination');visited.add(next);
        const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);let html;
        try{const response=await fetch(next,{signal:controller.signal,credentials:'same-origin'});if(!response.ok)throw Error('catalog');html=await response.text();}finally{clearTimeout(timer);}
        const documentPart=new DOMParser().parseFromString(html,'text/html'),feed=documentPart.querySelector('[data-picker-feed]');if(!feed)throw Error('feed');
        feed.querySelectorAll('template[data-picker-record]').forEach(template=>{
          const d=template.dataset;if(!items.has(d.id)){const record=facts({id:d.id,title:d.title,kind:d.kind,source:d.source,price:Number(d.price),template}),override=overrides.get(d.id);if(override){if(Number(override.laptop)>0){record.laptop=Number(override.laptop);record.laptopCandidate=true;}record.uses=[...new Set(record.uses.concat((override.uses||'').split(' ').filter(Boolean)))];}items.set(d.id,record);}
        });
        next=null;if(feed.dataset.next){const url=new URL(feed.dataset.next,first);if(url.origin!==first.origin||url.pathname!==first.pathname)throw Error('path');url.searchParams.set('section_id','sooqja-picker-catalog');next=url.href;}
      }
      records=[...items.values()];status.textContent=root.dataset.loaded.replace('[count]',records.length);return records;
    })();
    try{return await pending;}catch(error){status.textContent=root.dataset.error;throw error;}finally{pending=null;submit.disabled=false;}
  }
  function append(){
    const chunk=visible.slice(shown,shown+12),fragment=document.createDocumentFragment();
    chunk.forEach(record=>{const copy=record.template.content.cloneNode(true);if(record.uncertain){const note=document.createElement('p');note.className='sq-picker__reason';note.textContent=root.dataset.uncertain;const contact=document.createElement('a');contact.href='https://wa.me/962793303329';contact.textContent=root.dataset.confirm;note.append(' ',contact);copy.querySelector('[data-picker-card]').append(note);}fragment.append(copy);});
    grid.append(fragment);shown+=chunk.length;more.hidden=shown>=visible.length;
  }
  function display(){
    if(!records)return;const data=new FormData(form),filters={use:data.get('use'),laptop:Number(data.get('laptop')),budget:Number(data.get('budget'))},selection=select(records,filters);
    unknown.closest('label').hidden=selection.unknown.length===0;
    root.querySelector('[data-picker-unknown-label]').textContent=root.dataset.unknown.replace('[count]',selection.unknown.length);
    visible=selection.matches.concat(unknown.checked?selection.unknown.map(r=>({...r,uncertain:true})):[]);shown=0;grid.replaceChildren();append();
    result.hidden=false;root.querySelector('[data-picker-empty]').hidden=visible.length>0;
    const title=root.querySelector('[data-picker-title]');title.textContent=root.dataset.count.replace('[count]',selection.matches.length);title.hidden=false;
    window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'sooqja_picker_result',...filters,result_count:selection.matches.length,catalog_count:records.length});
  }
  form.addEventListener('submit',async e=>{e.preventDefault();const token=++request;try{await load();if(token!==request||!root.isConnected)return;display();root.querySelector('[data-picker-title]').focus({preventScroll:true});}catch(error){result.hidden=true;}});
  form.addEventListener('change',()=>{request++;result.hidden=true;unknown.checked=false;});
  unknown.addEventListener('change',display);more.addEventListener('click',append);
  details.addEventListener('toggle',()=>{if(details.open)load().catch(()=>{});});if(details.open)load().catch(()=>{});
});}
init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
